import CompanyDebitFormForm from './companyDebitFormForm';

export default CompanyDebitFormForm;
